<template>
<div class="kcb-cert">
    <slot name="activator" :on="{ click: open }" />
</div>
</template>

<script>
// KCB 휴대폰본인확인(표준창) — 쿠콘 경유. kcp-cert.vue 와 같은 인터페이스(open(), input/complete/change 이벤트, payload 형태).
// KCB 규격서가 iframe 사용을 지양하라고 해서(쿠키 문제) PC·모바일 모두 새 창으로 띄운다. 앱 WebView 는 window.open 을 새 창으로 처리한다.
export default {
    mounted() {
        window.authComplete = (payload) => {
            this.$emit("complete", payload);
            this.$emit("change", payload);
            this.$emit("input", payload);
        };
    },
    beforeDestroy() {
        window.authComplete = undefined;
    },
    methods: {
        // 팝업 차단을 피하려면 클릭 처리 안에서 동기적으로 열어야 한다. API 호출은 열린 창(request 페이지)이 한다.
        open() {
            const isMobile = navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("iPhone") > -1;

            let feature = "";
            if (!isMobile) {
                const width = 430;
                const height = 640;
                const left = screen.width / 2 - width / 2;
                const top = screen.height / 2 - height / 2;
                feature = `width=${width}, height=${height}, toolbar=no, status=no, statusbar=no, menubar=no, scrollbars=yes, resizable=no, left=${left}, top=${top}`;
            }

            window.open("/plugins/kcb/cert/request", "auth_popup", feature);
        },
        auth() {
            this.open();
        },
    },
};
</script>
